import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e09d8ac9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md" }, null, -1))
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-4 text-center" }, "Site settings", -1))
const _hoisted_6 = { class: "table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"50%"}
  }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"50%"}
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Theme", -1))
const _hoisted_9 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_10 = { class: "badge bg-light" }
const _hoisted_11 = { class: "badge bg-light" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Paged page behaviour ", -1))
const _hoisted_13 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Show open in-game help dialog", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Show recent posts box", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Time label format", -1))
const _hoisted_17 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Store comment drafts", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Automatically resize text boxes", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Always show navbar on top", -1))
const _hoisted_21 = { class: "badge bg-light" }
const _hoisted_22 = { class: "badge bg-light" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md" }, null, -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TitleTag = _resolveComponent("TitleTag")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Switch = _resolveComponent("Switch")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleTag, { title: "Website settings" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.theme,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.theme) = $event)),
                      value: "light"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Light")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.theme,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.theme) = $event)),
                      value: "dark"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Dark")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.theme,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.theme) = $event)),
                      value: "auto"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Automatic "),
                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode("?")
                        ])), [
                          [_directive_tooltip, `If automatic theme is enabled the site will match your browser or OS's theme setting, which can be useful for enabling dark mode only at night.`]
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createTextVNode(" Remember scroll position "),
                  _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createTextVNode("?")
                  ])), [
                    [_directive_tooltip, 'When reloading or navigating away from a page, your scroll position will be saved and restored when you come back to it. You can disable this behaviour if you find it annoying.']
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.autoScroll,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.autoScroll) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.infiniteScroll,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.infiniteScroll) = $event)),
                      value: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Infinite")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.infiniteScroll,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.infiniteScroll) = $event)),
                      value: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Paginated")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.showOpenInGameDialog,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.showOpenInGameDialog) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.showRecent,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.showRecent) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.timeFormat,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.timeFormat) = $event)),
                      value: "relative"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Relative")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.timeFormat,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.timeFormat) = $event)),
                      value: "datetime"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Date and time")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_18,
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.storeCommentDraft,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.storeCommentDraft) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_19,
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.autoResizeBoxes,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.autoResizeBoxes) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_20,
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.fixedNavbar,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.fixedNavbar) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createTextVNode("Enable server side rendering "),
                  _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _createTextVNode("?")
                  ])), [
                    [_directive_tooltip, 'If enabled, the page will be rendered on the server before being sent to you. This can improve performance, but it may also cause some unintended behavior.']
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.enableSSR,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.enableSSR) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createTextVNode("Enable analytics "),
                  _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createTextVNode("?")
                  ])), [
                    [_directive_tooltip, `We use sentry.io in order to collect information about errors and website performance. This shouldn't affect your experience in any way, but you can still choose to disable it.`]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createVNode(_component_Switch, {
                    modelValue: _ctx.analytics,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.analytics) = $event))
                  }, null, 8, ["modelValue"]), [
                    [_directive_tooltip, 'Changing this setting will reload the page']
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_23
      ])
    ])
  ], 64))
}